import React, {useCallback} from "react"
import {HeaderComponentProps, PaginatedSelector} from "@/components/paginated-selector/paginated-selector";
import {apiV2} from "@/api/axiosConfig";
import {convertV1ToV2, PaginatedResponse} from "@/types/PaginatedResponse";
import {useAuth} from "@/context/user";
import {ClientFilter} from "@/components/paginated-selector/filters/ClientFilter";
import {FilterQueryParams} from "@/components/paginated-selector/filters/types";

type IncidentFeed = {
    id: string;
    name: string;
    clientID: string;
    clientName: string;
    type: string;
    reference: string;
}

type IncidentFeedSelectorProps = {
    renderActions?: (feed: IncidentFeed) => React.ReactNode;
    onColumnClick?: (feed: IncidentFeed, columnIndex: number) => void;
}

export function IncidentFeedSelector({renderActions, onColumnClick}: IncidentFeedSelectorProps) {
    const {isSuperAdmin} = useAuth();

    const headers = [
        "Name",
        "Client",
        "Type",
        "Reference"
    ]

    const renderHeader = useCallback((props: HeaderComponentProps) => {
        // Column 1 is Client - make it filterable for super admins
        if (props.columnIndex === 1 && isSuperAdmin) {
            return <ClientFilter {...props} />;
        }
        return props.label;
    }, [isSuperAdmin]);

    const getIncidentFeeds = useCallback(async (search: string, page: number, filterParams?: FilterQueryParams) => {
        const params: any = {
            search: search,
            page: page,
            limit: 10,
            ...filterParams,
        }

        const res = await apiV2.get<PaginatedResponse<any>>("incident-feeds", {params})

        return convertV1ToV2(res.data, 10)
    }, [])
    

    const formatFeedType = (type: string) => {
        if (type === "intelligence_fusion") return "Default";
        return type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    }

    const getColumns = useCallback((feed: IncidentFeed) => {
        return [
            feed.name,
            feed.clientName,
            formatFeedType(feed.type),
            feed.reference
        ]
    }, [isSuperAdmin])

    return <PaginatedSelector
        headers={headers}
        getItems={getIncidentFeeds}
        getColumns={getColumns}
        disableSelect={true}
        renderActions={renderActions}
        onColumnClick={onColumnClick}
        renderHeader={renderHeader}
        syncWithUrl={true}
    />
}
